import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import {
  Panel,
  Modal,
  Row,
  Col,
  Uploader,
  Icon,
  Table,
  ButtonGroup,
  IconButton,
  Input,
  Button,
  Message,
  Loader,
  ControlLabel,
  SelectPicker,
} from 'rsuite'
import { isRequired, isValidators, isImageOrPdf } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import CustomIconMessageInfo from '../CustomIconMessageInfo'
import classNames from 'classnames'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { API_ROOT } from '../../config/config'
import notification from '../../utils/notification'
import ConfirmWidget from '../confirm/ConfirmWidget'
import '../../pages/proposal/styles.less'

export default function AttachFilesGranteeContract({
  schema,
  onUpdate = () => {},
  onDelete = () => {},
  onPreview = () => {},
  onDownload = () => {},
  onUploadError = () => {},
  onUploadSuccess = () => {},
  isContract,
  disabledForm,
  isStaff,
  onValidateFile = () => {},
  ...props
}) {
  const { isEditErr, isUploadErr, isDeleteError, loading } = props
  const { Column, HeaderCell, Cell } = Table
  const [fileList, setFileList] = useState([])
  const [attachFiles, setAttachFiles] = useState([])
  const [selectEditeIndex, setSelectEditeIndex] = useState(-1)
  const [editName, setEditName] = useState()
  const [deleteIndex, setDeleteIndex] = useState()
  const [isAdd, setIsAdd] = useState(false)
  const [isDeleteFail, setIsDeleteFail] = useState(false)
  const [isUploadError, setIsUploadError] = useState(false)
  const [isEditError, setIsEditError] = useState(false)
  const [isdelete, setIsdelete] = useState(false)
  const [deleteId, setDeleteId] = useState()
  const [fileTypeError, setFileTypeError] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [accessToken, setAccessToken] = useState()
  const [showConfirm, setShowConfirm] = useState(false)
  const [fileId, setFileId] = useState(false)
  const [rowDataItem, setRowDataItem] = useState(false)

  useEffect(() => {
    const _accessToken = localStorage.getItem('access_token')
    setAccessToken(_accessToken)
  }, [])

  useEffect(() => {
    console.log('AttachFilesForm schema', schema.attachFiles)
    let dummyFile = {
      contractFileType: 'เอกสารคุณสมบัติอื่นๆ (ถ้ามี)',
      contractFileTypeId: '27DE34FC-D460-46BB-9055-F706DCE89859',
      uploadDate: '2021-08-02T18:06:02.32',
      isChecked: false,
      enableDelete: true,
      label: '',
      name: '',
      path: '',
      type: null,
      size: 0,
      id: '4D2AEFD3-D356-4F0C-B632-2C45D75BC266',
    }
    setAttachFiles([...(schema.attachFiles.value || [])])
    if (!isEditErr) {
      setEditName()
      setSelectEditeIndex(-1)
    }
  }, [schema.attachFiles])

  useEffect(() => {
    setIsDeleteFail(isDeleteError)
  }, [isDeleteError])

  useEffect(() => {
    if (!isEditErr) {
      console.log('isEditErr', isEditErr)
    }
    setIsEditError(isEditErr)
  }, [isEditErr])

  useEffect(() => {
    setIsUploadError(isUploadErr)
    setIsAdd(isUploadErr)
  }, [isUploadErr])

  const onAdd = () => {
    setIsAdd(true)
    setFileList([])
  }

  const onAddFile = (file) => {
    setFileList(file)
    setValue(schema.attachFiles.name, file)
  }

  const handleDeleteFile = (rowData, index) => {
    setDeleteIndex(index)
    setDeleteId(rowData.id)
    setIsdelete(true)
  }

  const handleEditFile = (rowData, index) => {
    setEditName(rowData.label)
    setSelectEditeIndex(index)
  }

  const setRowData = (id, newData) => {
    setAttachFiles((state) => {
      return state.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            ...newData,
          }
        }
        return item
      })
    })
  }

  const handleUpload = (contractFileTypeId) => {
    if (isContract) {
      return `${API_ROOT}/contract/${projectId}/attachments`
    } else {
      return `${API_ROOT}/proposal/${projectId}/grantee/attachment/${contractFileTypeId}`
    }
  }

  const handleOnClickCheckFile = (rowData) => {
    setFileId(rowData.id)
    setRowDataItem(rowData)
    setShowConfirm(true)
  }

  const validateEditFileName = (rowData, index) => {
    if (selectEditeIndex == index) {
      return (
        <Row>
          {isEditError && (
            <Col style={{ marginBottom: 10 }}>
              <Message showIcon type="error" description={`แก้ไขไม่สำเร็จ`} />
            </Col>
          )}
          <Col xs={19} sm={19} md={19} lg={19}>
            <Input value={editName} onChange={(value) => setEditName(value)} />
          </Col>
          <Col xs={5} sm={5} md={5} lg={5}>
            <ButtonGroup>
              <IconButton
                appearance="ghost"
                icon={<Icon icon="check" className="bt-gost-icon-radius" />}
                onClick={(e) => {
                  onUpdate(rowData, editName)
                }}
              />
              <IconButton
                appearance="ghost"
                className="rs-btn-ghost-cancel"
                icon={<Icon icon="close" className="bt-gost-icon-radius-cancel" />}
                onClick={(e) => {
                  setEditName('')
                  setIsEditError(false)
                  setSelectEditeIndex(-1)
                }}
              />
            </ButtonGroup>
          </Col>
        </Row>
      )
    } else {
      return rowData.label
    }
  }

  return (
    <div className="proposal-grantee-attach-files">
      <Message
        showIcon
        type="info"
        style={{ width: '100%' }}
        description={'ชนิดที่รองรับ : .jpg, .jpeg, .png, .pdf ขนาดไฟล์ไม่เกิน 50 MB'}
      />
      <Message
        showIcon
        type="warning"
        style={{ width: '100%' }}
        description={
          <p>
            กรุณาแนบไฟล์ ตามประเภทเอกสารที่ระบุไว้เท่านั้น{' '}
            <span style={{ color: 'red' }}>* กรณีรวมไฟล์รบกวนแตกไฟล์ก่อนแนบ</span>
          </p>
        }
      />
      {schema?.attachFiles?.description && (
        <Row style={{ marginTop: 10, width: '100%' }}>
          <CustomIconMessageInfo contents={schema.attachFiles.description} />
        </Row>
      )}
      <Row style={{ marginTop: 10, width: '100%' }}>
        {isDeleteFail && (
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            style={{ marginTop: 10, marginBottom: 10, width: '100%' }}
          >
            <Message showIcon type="error" description={isDeleteFail} />
          </Col>
        )}
        <Col xs={24} sm={24} md={24} lg={24} style={{ width: '100%' }}>
          <Table
            autoHeight
            height={300}
            wordWrap
            bordered
            data={attachFiles}
            className="proposal-grantee-attach-files-table"
            style={{ width: '100%' }}
          >
            <Column width={90} align="center" fixed>
              <HeaderCell>ไฟล์ที่</HeaderCell>
              <Cell>
                {(_, index) => {
                  return index + 1
                }}
              </Cell>
            </Column>

            <Column minWidth={300} flexGrow={2}>
              <HeaderCell>ประเภทไฟล์</HeaderCell>
              <Cell>
                {(rowData, index) => {
                  //return validateEditFileName(rowData, index)
                  if (rowData.isRequired) {
                    return (
                      <span>
                        <span style={{ color: 'red' }}>*</span>
                        {rowData.contractFileType}
                      </span>
                    )
                  } else {
                    return rowData.contractFileType
                  }
                }}
              </Cell>
            </Column>

            <Column minWidth={100} flexGrow={1}>
              <HeaderCell>ชื่อไฟล์</HeaderCell>
              <Cell>
                {(rowData, index) => {
                  //return validateEditFileName(rowData, index)
                  if (rowData.label) {
                    return rowData.label
                  } else {
                    return (
                      rowData.isRequired &&
                      !disabledForm && <span style={{ color: 'orange' }}>**กรุณาแนบไฟล์**</span>
                    )
                  }
                }}
              </Cell>
            </Column>

            <Column width={170} align="center" fixed="right">
              <HeaderCell className="proposal-grantee-attach-files-action-header">แนบเอกสาร</HeaderCell>
              <Cell className="proposal-grantee-attach-files-action-cell">
                {(rowData, index) => {
                  if (rowData.path) {
                    return (
                      <ButtonGroup>
                        <IconButton
                          appearance="ghost"
                          icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                          onClick={(e) => onPreview(rowData)}
                          disabled={loading}
                        />
                        <IconButton
                          appearance="ghost"
                          icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                          onClick={(e) => onDownload(rowData)}
                          disabled={loading}
                        />

                        {/* <IconButton
                      disabled={loading || selectEditeIndex == index}
                      icon={<Icon icon="pencil" />}
                      onClick={(e) => handleEditFile(rowData, index)}
                    /> */}
                        {!disabledForm && (
                          <IconButton
                            appearance="ghost"
                            className="rs-btn-ghost-cancel"
                            icon={
                              <Icon icon="trash-o" className="bt-gost-icon-none-radius-cancel" />
                            }
                            onClick={(e) => handleDeleteFile(rowData, index)}
                            disabled={!rowData.enableDelete || rowData.isChecked}
                          />
                        )}
                      </ButtonGroup>
                    )
                  } else {
                    return (
                      !disabledForm && (
                        <>
                          {rowData.isLoading && <Loader backdrop center />}
                          <Uploader
                            style={rowData.isLoading ? { display: 'none' } : {}}
                            accept=".jpg, .jpeg, .png, .pdf"
                            headers={{ Authorization: `Bearer ${accessToken}` }}
                            multiple={false}
                            fileList={rowData.isLoading ? [] : rowData.fileList}
                            onChange={(fileList) => {
                              setRowData(rowData.id, {
                                localFileList: fileList,
                              })
                            }}
                            onUpload={() => {
                              setRowData(rowData.id, {
                                isLoading: true,
                              })
                            }}
                            onSuccess={(response) => {
                              setRowData(rowData.id, {
                                fileLabel: response.label,
                                fileName: response.name,
                                filePath: response.path,
                                isLoading: false,
                                localFileList: [],
                              })
                              onUploadSuccess(response)
                            }}
                            onError={(e) => {
                              setRowData(rowData.id, {
                                isLoading: false,
                                localFileList: [],
                              })
                              onUploadError(e)
                              notification.open('error', {
                                title: 'แนบเอกสารไม่สำเร็จ',
                              })
                            }}
                            listType="picture"
                            action={handleUpload(rowData.contractFileTypeId)}
                            name={isContract ? 'Files' : 'file'}
                            data={{
                              FileId: rowData.id || '',
                              MasterContractFileId: rowData.contractFileTypeId || '',
                              ProjectVersionId: projectId || '',
                            }}
                          >
                            <button className="upload__button" style={{ marginTop: 0 }}>
                              <Icon icon="upload" size="lg" />
                            </button>
                          </Uploader>
                        </>
                      )
                    )
                  }
                }}
              </Cell>
            </Column>

            {isStaff && !disabledForm && (
              <Column width={210} fixed="right">
                <HeaderCell></HeaderCell>
                <Cell style={{ marginRight: 20 }}>
                  {(rowData) => {
                    if (rowData.path)
                      return (
                        <IconButton
                          icon={
                            <Icon
                              icon="check-circle"
                              style={{
                                color:
                                  rowData.isChecked || rowData.isValidated ? '#14997a' : '#8e8e93',
                              }}
                            />
                          }
                          tooltip={`แสดง`}
                          onClick={(e) => handleOnClickCheckFile(rowData)}
                        >
                          บันทึกตรวจสอบไฟล์
                        </IconButton>
                      )
                  }}
                </Cell>
              </Column>
            )}
          </Table>
        </Col>
      </Row>
      {/* </Panel> */}

      <ConfirmWidget
        size={'sm'}
        title={`ยืนยันการลบ`}
        show={isdelete}
        detail={`ยืนยันการลบไฟล์`}
        onCancle={() => {
          setIsdelete(false), setDeleteIndex(''), setDeleteId('')
        }}
        onConfirm={() => {
          onDelete(deleteId), setIsdelete(false)
        }}
      />

      <ConfirmWidget
        size={'sm'}
        title={`บันทึกตรวจสอบไฟล์`}
        show={showConfirm}
        detail={`การบันทึกตรวจสอบไฟล์ ทำให้ภาคีไม่สามารถลบไฟล์นี้ได้อีก`}
        onCancle={() => setShowConfirm(false)}
        onConfirm={() => {
          onValidateFile(rowDataItem), setShowConfirm(false)
        }}
      />
    </div>
  )
}
